import React, { FC } from 'react';

export const IconArrowDown: FC<React.PropsWithChildren<unknown>> = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.49878 1L6.49878 11" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.4988 6L6.49878 11L1.49878 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
